import styled from 'styled-components';

export const StyledDealSummaryIcon = styled.svg`
    display: block;
`;
